/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ErrorInfo,
  GetManuscriptsSettings200,
  ProductionManuscriptsSetting,
  ManuscriptInfo,
  ManuscriptRevisions,
  PostManuscriptsReadFlistCheck200,
  PostManuscriptsReadFlistBody,
  PostManuscriptsCreateDomCheck200,
  BinaryFile,
  PostManuscriptsCreateWebomCheck200,
  PostManuscriptsCreateWebOmBody,
  PostManuscriptsCreateOri200,
  PostManuscriptsCreateNewOri200,
  PostManuscriptsOutputErrorList200,
  PostManuscriptsOutputErrorListBody,
  ManuscriptPsTemporaryList,
  PostManuscriptsPstemporarylistImport200,
  PostManuscriptsPstemporarylistImportBody,
  PostManuscriptsPstemporarylistExport200
} from '.././model'


/**
 * 制作管理（原稿タブ）の編集ロック処理。  
制作管理編集テーブルのレコードに編集対象、編集ロックセッションID、開始日時、有効期限等を設定する。
現在ロックをしているセッションから呼ばれたときは、編集ロックの有効期限を延長する。

 * @summary 制作管理（原稿タブ）編集ロック
 */
export const postManuscriptsLock = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/manuscripts/lock/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsLockMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsLock>>>
    
    export type PostManuscriptsLockMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsLock = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsLock>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsLock>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsLock(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsLock>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理（原稿タブ）の編集をキャンセルし、編集ロックを解除する。

 * @summary 制作管理（原稿タブ）編集キャンセル・ロック解除
 */
export const postManuscriptsCancel = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/manuscripts/cancel/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsCancel>>>
    
    export type PostManuscriptsCancelMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsCancel = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsCancel>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsCancel>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsCancel(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsCancel>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 原稿タブの設定情報取得

 * @summary 原稿タブの設定情報取得
 */
export const getManuscriptsSettings = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManuscriptsSettings200>> => {
    return axios.get(
      `/manuscripts/${productionId}/settings`,options
    );
  }


export const getGetManuscriptsSettingsQueryKey = (productionId: number,) => [`/manuscripts/${productionId}/settings`];

    
export type GetManuscriptsSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getManuscriptsSettings>>>
export type GetManuscriptsSettingsQueryError = AxiosError<ErrorInfo>

export const useGetManuscriptsSettings = <TData = Awaited<ReturnType<typeof getManuscriptsSettings>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManuscriptsSettings>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetManuscriptsSettingsQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getManuscriptsSettings>>> = ({ signal }) => getManuscriptsSettings(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getManuscriptsSettings>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 原稿タブの設定情報保存

 * @summary 原稿タブの設定情報保存
 */
export const postManuscriptsSettingsSave = (
    productionId: number,
    productionManuscriptsSetting: ProductionManuscriptsSetting, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(productionManuscriptsSetting.production_id !== undefined) {
 formData.append('production_id', productionManuscriptsSetting.production_id.toString())
 }
if(productionManuscriptsSetting.include_navi !== undefined) {
 formData.append('include_navi', productionManuscriptsSetting.include_navi.toString())
 }
if(productionManuscriptsSetting.navi_production_no !== undefined) {
 formData.append('navi_production_no', productionManuscriptsSetting.navi_production_no)
 }
if(productionManuscriptsSetting.l1_title_jp !== undefined) {
 formData.append('l1_title_jp', productionManuscriptsSetting.l1_title_jp)
 }
if(productionManuscriptsSetting.l1_title_en !== undefined) {
 formData.append('l1_title_en', productionManuscriptsSetting.l1_title_en)
 }
if(productionManuscriptsSetting.apply_stretch !== undefined) {
 formData.append('apply_stretch', productionManuscriptsSetting.apply_stretch.toString())
 }
if(productionManuscriptsSetting.font_stretch !== undefined) {
 formData.append('font_stretch', productionManuscriptsSetting.font_stretch)
 }
if(productionManuscriptsSetting.line_height !== undefined) {
 formData.append('line_height', productionManuscriptsSetting.line_height)
 }

    return axios.post(
      `/manuscripts/${productionId}/settings/save`,
      formData,options
    );
  }



    export type PostManuscriptsSettingsSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsSettingsSave>>>
    export type PostManuscriptsSettingsSaveMutationBody = ProductionManuscriptsSetting
    export type PostManuscriptsSettingsSaveMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsSettingsSave = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsSettingsSave>>, TError,{productionId: number;data: ProductionManuscriptsSetting}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsSettingsSave>>, {productionId: number;data: ProductionManuscriptsSetting}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postManuscriptsSettingsSave(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsSettingsSave>>, TError, {productionId: number;data: ProductionManuscriptsSetting}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 指定された制作管理IDに紐づく原稿一覧を取得する。

 * @summary 原稿一覧取得
 */
export const getManuscriptsInfo = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ManuscriptInfo>> => {
    return axios.get(
      `/manuscripts/info/${productionId}`,options
    );
  }


export const getGetManuscriptsInfoQueryKey = (productionId: number,) => [`/manuscripts/info/${productionId}`];

    
export type GetManuscriptsInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getManuscriptsInfo>>>
export type GetManuscriptsInfoQueryError = AxiosError<ErrorInfo>

export const useGetManuscriptsInfo = <TData = Awaited<ReturnType<typeof getManuscriptsInfo>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManuscriptsInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetManuscriptsInfoQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getManuscriptsInfo>>> = ({ signal }) => getManuscriptsInfo(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getManuscriptsInfo>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 指定された制作管理IDに紐づく原稿一覧を取得する。

 * @summary 原稿一覧取得
 */
export const postManuscriptsRevision = (
    productionId: number,
    chapterNumberId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ManuscriptRevisions>> => {
    return axios.post(
      `/manuscripts/revision/${productionId}/${chapterNumberId}`,undefined,options
    );
  }



    export type PostManuscriptsRevisionMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsRevision>>>
    
    export type PostManuscriptsRevisionMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsRevision = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsRevision>>, TError,{productionId: number;chapterNumberId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsRevision>>, {productionId: number;chapterNumberId: number}> = (props) => {
          const {productionId,chapterNumberId} = props ?? {};

          return  postManuscriptsRevision(productionId,chapterNumberId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsRevision>>, TError, {productionId: number;chapterNumberId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * F-Listが読込済みの状態で、再度、F-Listをインポートする場合、既存のデータがすべて上書きされ、手で修正した内容もクリアすることを確認メッセージで表示する。
そのためのチェックを行う。

 * @summary F-List読込前のチェック
 */
export const postManuscriptsReadFlistCheck = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManuscriptsReadFlistCheck200>> => {
    return axios.post(
      `/manuscripts/readFListCheck/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsReadFlistCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsReadFlistCheck>>>
    
    export type PostManuscriptsReadFlistCheckMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsReadFlistCheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsReadFlistCheck>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsReadFlistCheck>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsReadFlistCheck(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsReadFlistCheck>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * F-Listファイルをアップロードし、ベース原稿テーブルにF-List判定データを保存する。

 * @summary F-List読込
 */
export const postManuscriptsReadFlist = (
    productionId: number,
    postManuscriptsReadFlistBody: PostManuscriptsReadFlistBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(postManuscriptsReadFlistBody.file !== undefined) {
 formData.append('file', postManuscriptsReadFlistBody.file)
 }

    return axios.post(
      `/manuscripts/readFList/${productionId}`,
      formData,options
    );
  }



    export type PostManuscriptsReadFlistMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsReadFlist>>>
    export type PostManuscriptsReadFlistMutationBody = PostManuscriptsReadFlistBody
    export type PostManuscriptsReadFlistMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsReadFlist = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsReadFlist>>, TError,{productionId: number;data: PostManuscriptsReadFlistBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsReadFlist>>, {productionId: number;data: PostManuscriptsReadFlistBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postManuscriptsReadFlist(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsReadFlist>>, TError, {productionId: number;data: PostManuscriptsReadFlistBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 必要データが揃っていない場合はエラーとなりダイアログでエラーメッセージを表示する。必要データがすべて整っている場合は確認ダイアログを表示し「はい」を選択することで処理を実行する。
そのためのチェックを行う。

 * @summary dOM生成前のチェック
 */
export const postManuscriptsCreateDomCheck = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManuscriptsCreateDomCheck200>> => {
    return axios.post(
      `/manuscripts/createDOMCheck/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsCreateDomCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsCreateDomCheck>>>
    
    export type PostManuscriptsCreateDomCheckMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsCreateDomCheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsCreateDomCheck>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsCreateDomCheck>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsCreateDomCheck(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsCreateDomCheck>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * dOMファイルを生成してダウンロードする。

 * @summary dOM生成
 */
export const postManuscriptsCreateDom = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/manuscripts/createDOM/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsCreateDomMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsCreateDom>>>
    
    export type PostManuscriptsCreateDomMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsCreateDom = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsCreateDom>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsCreateDom>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsCreateDom(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsCreateDom>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 必要データが揃っていない場合はエラーとなりダイアログでエラーメッセージを表示する。必要データがすべて整っている場合は確認ダイアログを表示し「はい」を選択することで処理を実行する。
そのためのチェックを行う。

 * @summary WebOM生成前のチェック
 */
export const postManuscriptsCreateWebomCheck = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManuscriptsCreateWebomCheck200>> => {
    return axios.post(
      `/manuscripts/createWebOMCheck/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsCreateWebomCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsCreateWebomCheck>>>
    
    export type PostManuscriptsCreateWebomCheckMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsCreateWebomCheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsCreateWebomCheck>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsCreateWebomCheck>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsCreateWebomCheck(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsCreateWebomCheck>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * WebOMファイルを生成してダウンロードする。

 * @summary WebOM生成
 */
export const postManuscriptsCreateWebOm = (
    productionId: number,
    postManuscriptsCreateWebOmBody: PostManuscriptsCreateWebOmBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/manuscripts/createWebOM/${productionId}`,
      postManuscriptsCreateWebOmBody,options
    );
  }



    export type PostManuscriptsCreateWebOmMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsCreateWebOm>>>
    export type PostManuscriptsCreateWebOmMutationBody = PostManuscriptsCreateWebOmBody
    export type PostManuscriptsCreateWebOmMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsCreateWebOm = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsCreateWebOm>>, TError,{productionId: number;data: PostManuscriptsCreateWebOmBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsCreateWebOm>>, {productionId: number;data: PostManuscriptsCreateWebOmBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postManuscriptsCreateWebOm(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsCreateWebOm>>, TError, {productionId: number;data: PostManuscriptsCreateWebOmBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 参照リストを生成してダウンロードする。

 * @summary 参照リスト出力
 */
export const postManuscriptsOutputReference = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/manuscripts/outputReference/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsOutputReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsOutputReference>>>
    
    export type PostManuscriptsOutputReferenceMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsOutputReference = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsOutputReference>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsOutputReference>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsOutputReference(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsOutputReference>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ベース本からORIデータを作成（F-List判定がない場合）

 * @summary ORIデータ複製
 */
export const postManuscriptsCreateOri = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManuscriptsCreateOri200>> => {
    return axios.post(
      `/manuscripts/createOri/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsCreateOriMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsCreateOri>>>
    
    export type PostManuscriptsCreateOriMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsCreateOri = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsCreateOri>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsCreateOri>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsCreateOri(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsCreateOri>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ORIデータを新規で作成

 * @summary ORIデータ新規作成
 */
export const postManuscriptsCreateNewOri = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManuscriptsCreateNewOri200>> => {
    return axios.post(
      `/manuscripts/createNewOri/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsCreateNewOriMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsCreateNewOri>>>
    
    export type PostManuscriptsCreateNewOriMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsCreateNewOri = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsCreateNewOri>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsCreateNewOri>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsCreateNewOri(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsCreateNewOri>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ORIデータ複製前チェック

 * @summary ORIデータ複製前チェック
 */
export const postManuscriptsCheckCreateOri = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/manuscripts/checkCreateOri/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsCheckCreateOriMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsCheckCreateOri>>>
    
    export type PostManuscriptsCheckCreateOriMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsCheckCreateOri = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsCheckCreateOri>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsCheckCreateOri>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsCheckCreateOri(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsCheckCreateOri>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * frameMaker用XMLダウンロード

 * @summary frameMaker用XMLダウンロード
 */
export const postManuscriptsOutputFrame = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/manuscripts/outputFrameXml/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsOutputFrameMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsOutputFrame>>>
    
    export type PostManuscriptsOutputFrameMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsOutputFrame = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsOutputFrame>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsOutputFrame>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsOutputFrame(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsOutputFrame>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 索引リストを生成してダウンロードする。

 * @summary 索引リスト出力
 */
export const postManuscriptsOutputIndex = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/manuscripts/outputIndex/${productionId}`,undefined,options
    );
  }



    export type PostManuscriptsOutputIndexMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsOutputIndex>>>
    
    export type PostManuscriptsOutputIndexMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsOutputIndex = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsOutputIndex>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsOutputIndex>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManuscriptsOutputIndex(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsOutputIndex>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 原稿エラー一覧を出力する。

 * @summary 原稿エラー一覧
 */
export const postManuscriptsOutputErrorList = (
    productionId: number,
    postManuscriptsOutputErrorListBody: PostManuscriptsOutputErrorListBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManuscriptsOutputErrorList200>> => {
    return axios.post(
      `/manuscripts/outputErrorList/${productionId}`,
      postManuscriptsOutputErrorListBody,options
    );
  }



    export type PostManuscriptsOutputErrorListMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsOutputErrorList>>>
    export type PostManuscriptsOutputErrorListMutationBody = PostManuscriptsOutputErrorListBody
    export type PostManuscriptsOutputErrorListMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsOutputErrorList = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsOutputErrorList>>, TError,{productionId: number;data: PostManuscriptsOutputErrorListBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsOutputErrorList>>, {productionId: number;data: PostManuscriptsOutputErrorListBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postManuscriptsOutputErrorList(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsOutputErrorList>>, TError, {productionId: number;data: PostManuscriptsOutputErrorListBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃状況リスト取得

 * @summary PS改廃状況リスト取得
 */
export const getManuscriptsPstemporarylist = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ManuscriptPsTemporaryList>> => {
    return axios.get(
      `/manuscripts/pstemporarylist/${productionId}`,options
    );
  }


export const getGetManuscriptsPstemporarylistQueryKey = (productionId: number,) => [`/manuscripts/pstemporarylist/${productionId}`];

    
export type GetManuscriptsPstemporarylistQueryResult = NonNullable<Awaited<ReturnType<typeof getManuscriptsPstemporarylist>>>
export type GetManuscriptsPstemporarylistQueryError = AxiosError<ErrorInfo>

export const useGetManuscriptsPstemporarylist = <TData = Awaited<ReturnType<typeof getManuscriptsPstemporarylist>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManuscriptsPstemporarylist>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetManuscriptsPstemporarylistQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getManuscriptsPstemporarylist>>> = ({ signal }) => getManuscriptsPstemporarylist(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getManuscriptsPstemporarylist>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS改廃状況インポート

 * @summary PS改廃状況インポート
 */
export const postManuscriptsPstemporarylistImport = (
    productionId: number,
    chapterNumberId: number,
    postManuscriptsPstemporarylistImportBody: PostManuscriptsPstemporarylistImportBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManuscriptsPstemporarylistImport200>> => {const formData = new FormData();
if(postManuscriptsPstemporarylistImportBody.file !== undefined) {
 formData.append('file', postManuscriptsPstemporarylistImportBody.file)
 }

    return axios.post(
      `/manuscripts/pstemporarylist/${productionId}/${chapterNumberId}/import`,
      formData,options
    );
  }



    export type PostManuscriptsPstemporarylistImportMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsPstemporarylistImport>>>
    export type PostManuscriptsPstemporarylistImportMutationBody = PostManuscriptsPstemporarylistImportBody
    export type PostManuscriptsPstemporarylistImportMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsPstemporarylistImport = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsPstemporarylistImport>>, TError,{productionId: number;chapterNumberId: number;data: PostManuscriptsPstemporarylistImportBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsPstemporarylistImport>>, {productionId: number;chapterNumberId: number;data: PostManuscriptsPstemporarylistImportBody}> = (props) => {
          const {productionId,chapterNumberId,data} = props ?? {};

          return  postManuscriptsPstemporarylistImport(productionId,chapterNumberId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsPstemporarylistImport>>, TError, {productionId: number;chapterNumberId: number;data: PostManuscriptsPstemporarylistImportBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃状況エクスポート

 * @summary PS改廃状況エクスポート
 */
export const postManuscriptsPstemporarylistExport = (
    productionId: number,
    chapterNumberId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManuscriptsPstemporarylistExport200>> => {
    return axios.post(
      `/manuscripts/pstemporarylist/${productionId}/${chapterNumberId}/export`,undefined,options
    );
  }



    export type PostManuscriptsPstemporarylistExportMutationResult = NonNullable<Awaited<ReturnType<typeof postManuscriptsPstemporarylistExport>>>
    
    export type PostManuscriptsPstemporarylistExportMutationError = AxiosError<ErrorInfo>

    export const usePostManuscriptsPstemporarylistExport = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuscriptsPstemporarylistExport>>, TError,{productionId: number;chapterNumberId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuscriptsPstemporarylistExport>>, {productionId: number;chapterNumberId: number}> = (props) => {
          const {productionId,chapterNumberId} = props ?? {};

          return  postManuscriptsPstemporarylistExport(productionId,chapterNumberId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuscriptsPstemporarylistExport>>, TError, {productionId: number;chapterNumberId: number}, TContext>(mutationFn, mutationOptions)
    }
    